import { FC } from "react";
import { TabProps } from "./types";

export const Tab: FC<TabProps> = ({ children, ...props }) => {
  return ( 
    <div {...props}>
      {children}
    </div>
  )
}

export default Tab;